import * as yup from 'yup';

export const USER_LIST = 'USERS/game_list';
export const USER_PAGER = 'USERS/game_pager';
export const USER_FILTER = 'USERS/game_filter';
export const USER_ITEM = 'USERS/game_item';

export const ACL_PAGER = 'ACL/pager';
export const ACL_CREATE_USER = 'ACL/create';
export const ACL_UPDATE_USER = 'ACL/update';
export const ACL_ROLE_LIST = 'ACL/role_list';
export const ACL_DELETE_USER = 'ACL/delete_user';
export const ACL_BILLER_LIST = 'ACL/biller_list';
export const ACL_SELECTED_USER = 'ACL/selected_user';
export const ACL_BILLER_OPTIONS = 'ACL/biller_options';
export const ACL_CHANGE_PASSWORD = 'ACL/change_password';
export const ACL_MFA_TOGGLE_ALL_USERS = 'ACL/mfa_toggle_all_users';

const required = 'This field is required';

export const CREATE_VALIDATION_SCHEMA = yup.object().shape({
  first_name: yup.string().required(required),
  last_name: yup.string().required(required),
  email_address: yup
    .string()
    .email('The email format is invalid')
    .required(required),
  role: yup.string().required(required),
  password: yup
    .string()
    .required(required)
    .min(8, 'At least 8 characters')
    .matches(/[A-Z]/, 'Must contain 1 uppercase letter')
    .matches(/[a-z]/, 'Must contain 1 lowercase letter')
    .matches(/[0-9]/, 'Must contain 1 numeric digit')
    .matches(/^(?=.*[!@#$%^&*])/, 'At least 1 special character (!@#$%&*)'),
  password_confirmation: yup
    .string()
    .required(required)
    .oneOf([yup.ref('password', '')], 'Password does not match'),
});

export const UPDATE_VALIDATION_SCHEMA = yup.object().shape({
  first_name: yup.string().required(required),
  last_name: yup.string().required(required),
  email_address: yup
    .string()
    .email('The email format is invalid')
    .required(required),
  role: yup.string().required(required),
});
